module.exports = __webpack_public_path__ + "img/consultation_b.8869a5f4.png";